import React, { useContext, useCallback, useState } from 'react';
import { FaxProvider } from '@mummssoftware/common-ui';
import { getSiteFaxList } from '@mummssoftware/utils/pimReader';
import { isAgencyEnabled, getUserName } from '@mummssoftware/utils/utils';
import { AppContext } from '../../context';

type VisitLogFaxProviderProps = {
  children: React.ReactNode;
};

export const VisitLogFaxProvider = ({ children }: VisitLogFaxProviderProps) => {
  const { agency, keycloak, currentUser } = useContext(AppContext);
  const [siteFaxList, setSiteFaxList] = useState<any[] | null>(null);

  const fetchFaxList = useCallback(async () => {
    if (!agency || !keycloak) return;
    const response = await getSiteFaxList(agency, keycloak);
    if (!(response instanceof Response)) {
      setSiteFaxList(response);
    }
  }, [agency, keycloak]);

  const isFaxEnabled = !!isAgencyEnabled(window.env?.faxAgency, currentUser);
  const getSenderName = useCallback(() => getUserName(currentUser), [
    currentUser,
  ]);

  const config = {
    siteFaxList,
    fetchFaxList,
    isFaxEnabled,
    getSenderName,
  };

  return <FaxProvider config={config}>{children}</FaxProvider>;
};

type VisitLogFaxBridgeProps = {
  embedded?: boolean;
  children: React.ReactNode;
};

/** Dashboard supplies FaxProvider via DashboardFaxProvider; standalone visit-log needs its own. */
export const VisitLogFaxBridge = ({
  embedded,
  children,
}: VisitLogFaxBridgeProps) =>
  embedded ? (
    <>{children}</>
  ) : (
    <VisitLogFaxProvider>{children}</VisitLogFaxProvider>
  );
